import { CircularProgressProps } from '@mui/material';
import { FC } from 'react';
import { UILoader } from '../ui/ui-loader';

interface Props {
  isLoading?: boolean;
  children?: React.ReactNode;
  LoaderProps?: CircularProgressProps;
}

const ComponentWithLoader: FC<Props> = ({ isLoading, LoaderProps, children }) => {
  if (isLoading) {
    return <UILoader {...LoaderProps} />;
  }

  return children;
};

export default ComponentWithLoader;
